// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as OrderPdf from "./OrderPdf.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as OrderRoutes from "../../app/Order/OrderRoutes.res.js";
import * as OrderMutations from "./OrderMutations.res.js";
import * as OrderArchiveModal from "./OrderArchiveModal.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderTableActions(props) {
  let onRequestNotification = props.onRequestNotification;
  let name = props.name;
  let id = props.id;
  let match = React.useState(() => false);
  let setArchiveModalOpened = match[1];
  let unarchiveOrder = OrderMutations.useUnarchive(id, undefined);
  let handleDownloadPdf = () => {
    Future.tapError(OrderPdf.requestAndOpen(id, name), param => {
      if (onRequestNotification !== undefined) {
        return onRequestNotification({
          TAG: "Error",
          _0: OrderPdf.errorMessage
        });
      }
    });
  };
  let match$1 = props.statuses[0];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsxs(MenuActions.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: JsxRuntime.jsx(MenuActions.Item.make, {
                title: I18n.t("See"),
                href: OrderRoutes.showRoute(id),
                icon: "see_ok"
              })
            }),
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: JsxRuntime.jsx(MenuActions.Item.make, {
                title: I18n.t("Download PDF"),
                icon: "pdf_see",
                onAction: handleDownloadPdf
              })
            }),
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: match$1 === "ARCHIVED" ? JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Unarchive"),
                  tone: "brand",
                  icon: "archive",
                  onAction: () => {
                    unarchiveOrder();
                  }
                }) : JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Archive"),
                  tone: "danger",
                  icon: "unarchive",
                  onAction: () => setArchiveModalOpened(param => true)
                })
            })
          ],
          trigger: {
            TAG: "Compact",
            icon: "more_v2",
            size: "small",
            bold: true
          }
        }),
        align: "end"
      }),
      JsxRuntime.jsx(OrderArchiveModal.make, {
        orderId: id,
        opened: match[0],
        onRequestClose: () => setArchiveModalOpened(param => false),
        commitCallbackUrl: props.callbackUrlAfterArchiveAction
      })
    ]
  });
}

let make = React.memo(OrderTableActions);

export {
  make,
}
/* make Not a pure module */
